"use client";
export default function Button({ onClick, children, className }) {
	className = className ? className : "bg-accent-500 px-3 text-white";
	return (
		<div
			className={
				className +
				" no-select hu relative inline-flex cursor-pointer select-none items-center justify-center gap-2  whitespace-nowrap rounded active:top-px"
			}
			onClick={onClick}
		>
			{children}
		</div>
	);
}
